// SPDX-License-Identifier: AGPL-3.0-or-later

export interface PostedMessageNotice {
	content: string;
	authorId: string;
	/** Gateway MESSAGE_CREATE covers every subscribed channel, so listeners need to know which. */
	channelId: string;
}

type PostedMessageListener = (notice: PostedMessageNotice) => void;
const postedMessageListeners = new Set<PostedMessageListener>();

export function subscribePostedMessage(listener: PostedMessageListener): () => void {
	postedMessageListeners.add(listener);
	return () => {
		postedMessageListeners.delete(listener);
	};
}

export function notifyPostedMessage(notice: PostedMessageNotice): void {
	for (const listener of postedMessageListeners) {
		listener(notice);
	}
}
